import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Config from "config";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";

const InvestissmentDetail = () => {
  const type_compte = localStorage.getItem("typeDeCompte");
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [investData, setInvestData] = useState([]);

  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investissements | DETAILS";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails investissements"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  useEffect(() => {
    setLoading(true);
    const getData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/investissements/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        if (response.status === 401) {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("authUser");
          localStorage.removeItem("sideBar");
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        // if (!response.ok) {
        //   localStorage.removeItem("auth_token");
        //   localStorage.removeItem("authUser");
        //   localStorage.removeItem("sideBar");
        //   history("/backoffice_test/login");
        //   window.location.reload(false);
        //   throw new Error(`Request failed with status: ${response.status}`);
        // }

        const investData = await response.json();
        setInvestData(investData);
        setWait(0);
      } catch (error) {
        // Handle any other errors that might occur during the fetch
        console.error("Error fetching data:", error.message);
      }
    };

    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={
                              type_compte == "client"
                                ? `${backUrl}/pmes/${investData.detail_investissement?.["ids"]?.pme_id}`
                                : `${backUrl}/investissements`
                            }
                            style={{
                              color: "#3c88c8",
                              textDecoration: "underline !important",
                            }}
                          >
                            {type_compte == "client"
                              ? `${investData?.detail_investissement?.["Caractéristiques de l'investissement"]?.PME}`
                              : "Investissements"}
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        investData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {investData.can_edit ? (
                        <Link
                          to={`${backUrl}/investissements/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-info"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {investData.can_destroy ? (
                        <Link to="#!" className="btn btn-sm btn-danger">
                          <i className="bx bx-trash-alt"></i>Supprimer
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {investData?.detail_investissement?.[
                                "Caractéristiques de l'investissement"
                              ] ? (
                                <IdentificationCard
                                  title="Caractéristiques de l'investissement"
                                  details={
                                    investData?.detail_investissement?.[
                                      "Caractéristiques de l'investissement"
                                    ]
                                  }
                                />
                              ) : null}

                              {investData?.detail_investissement?.[
                                "Description"
                              ] ? (
                                <SouscriptionsCard
                                  title="Description"
                                  details={
                                    investData?.detail_investissement?.[
                                      "Description"
                                    ]
                                  }
                                />
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Honoraires"
                              ] ? (
                                <SouscriptionsCard
                                  title="Honoraires"
                                  details={
                                    investData?.detail_investissement?.[
                                      "Honoraires"
                                    ]
                                  }
                                />
                              ) : null}
                              {investData?.detail_investissement?.[
                                "Tableau des amortissements"
                              ] ? (
                                <Row>
                                  <Col sm="12">
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      Tableau des amortissements{" "}
                                    </CardTitle>
                                    <TableComponent
                                      header={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.header
                                      }
                                      data={
                                        investData?.detail_investissement?.[
                                          "Tableau des amortissements"
                                        ]?.["Tableau amortissements"]?.data
                                      }
                                    />
                                  </Col>
                                </Row>
                              ) : null}
                            </Col>

                            <Col sm="6">
                              <Row>
                                {investData?.detail_investissement?.[
                                  "Exploitation"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Exploitation"
                                    details={
                                      investData?.detail_investissement?.[
                                        "Exploitation"
                                      ]
                                    }
                                  />
                                ) : null}
                                {investData?.detail_investissement?.Loyers ? (
                                  <Row>
                                    <Col sm="12">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingBottom: "10px" }}
                                      >
                                        Loyers{" "}
                                      </CardTitle>
                                      <TableComponent
                                        header={
                                          investData?.detail_investissement
                                            ?.Loyers["Loyers investissement"]
                                            ?.header
                                        }
                                        data={
                                          investData?.detail_investissement
                                            ?.Loyers["Loyers investissement"]
                                            ?.data
                                        }
                                      />
                                    </Col>
                                  </Row>
                                ) : null}
                                {investData?.detail_investissement?.Audit ? (
                                  <SectionCard
                                    title="Audit"
                                    details={
                                      investData?.detail_investissement?.Audit
                                    }
                                  />
                                ) : null}
                              </Row>
                            </Col>

                            <>
                              {investData?.detail_pme?.documents.map(
                                (section, index) => (
                                  <Col
                                    sm={Math.min(
                                      Math.floor(
                                        12 /
                                          investData?.detail_pme?.documents
                                            .length
                                      ),
                                      12
                                    )}
                                  >
                                    <Row>
                                      <Card key={`section_${index}`}>
                                        <CardBody>
                                          <CardTitle
                                            className="mb-3"
                                            style={{ whiteSpace: "pretty" }}
                                          >
                                            {section.section_name}
                                          </CardTitle>

                                          {section.data.map((file, i) => (
                                            <Row
                                              key={`_file_${i}`}
                                              style={{
                                                borderBottom: "1px solid #eee",
                                                padding: "10px 0",
                                              }}
                                            >
                                              <Col
                                                xs={2}
                                                style={{ display: "" }}
                                              >
                                                <div className="avatar-sm">
                                                  <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-24">
                                                    <i className="bx bxs-file-doc" />
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={8}
                                                style={{
                                                  display: "inline-block",
                                                }}
                                              >
                                                <a
                                                  href={`https://www.fluxod.com/${api}/${
                                                    file?.link?.controller
                                                  }/${file?.link?.action}&${
                                                    Object.keys(
                                                      file.link.params
                                                    )[0]
                                                  }=${
                                                    file?.link?.params?.[
                                                      Object.keys(
                                                        file.link.params
                                                      )[0]
                                                    ]
                                                  }`}
                                                  className="text-dark"
                                                  style={{
                                                    textDecoration: "none",
                                                    display: "block",
                                                  }}
                                                >
                                                  <h5
                                                    className="font-size-14 mb-1"
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.nom}
                                                  </h5>
                                                  <small
                                                    style={{ paddingLeft: 10 }}
                                                  >
                                                    {file.type}
                                                  </small>
                                                </a>
                                              </Col>
                                              <Col xs={2}>
                                                <div
                                                  style={{
                                                    display: "inline-block",
                                                  }}
                                                >
                                                  {file.link && (
                                                    <a
                                                      href={`https://www.fluxod.com/${api}/${
                                                        file?.link?.controller
                                                      }/${file?.link?.action}&${
                                                        Object.keys(
                                                          file.link.params
                                                        )[0]
                                                      }=${
                                                        file?.link?.params?.[
                                                          Object.keys(
                                                            file.link.params
                                                          )[0]
                                                        ]
                                                      }`}
                                                      className="text-dark"
                                                    >
                                                      <i className="bx bx-download h3 m-0" />
                                                    </a>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Row>
                                  </Col>
                                )
                              )}
                            </>

                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default InvestissmentDetail;
